import React from 'react'
import './App.scss'
import bxlutils from 'bxl-utils'
import { BxlAnalytics } from 'bxl-analytics'
import { BXL_META_PREFIX } from './services/tracking'
import SearchBar from './components/SearchBar'
import SearchHistory from './module/SearchHistory'
import {
    searchProducts,
    getCartProductNum,
    loadPromoDetail,
    getHotWords
} from './services/searchService'
import ProductList from './module/productList'
import Loading from './module/Loading'
import Toast from './components/Toast'
import { tracker } from './lib/tracking'
import { BYH5, BXL_USER_ID, BXL_USER_KEY } from './lib/constants'
import FilterSearch from './module/FilterSearch'
import { remainTime } from './lib/timeFormat'
import ActionHeader from './components/ActionHeader'
import { MiniBridge, bxlNavigation, isMiniProgram } from 'bxl-miniParse'
const PAGE_LOCATION = 'H5_SPP'
tracker.send({
    webPageOpen: {
        pageName: 'search',
        url: window.location.href
    }
})
// 判断是否宽度超出机型
const ResetRem = () => {
    let clientWidth = document.documentElement.clientWidth
    if (!clientWidth) return
    let html = document.querySelector('html')
    if (clientWidth - window.screen.width > 10) {
        //rem有误差，不能直接设置大于或者等于
        html &&
            html.setAttribute(
                'style',
                `font-size:${(window.screen.width / clientWidth) * 10}vw`
            )
    }
}
let params = bxlutils.uri.parseUrlParams(window.location.href)
let slink = bxlutils.uri.stringify({
    utm_source: params.utm_source,
    utm_medium: params.utm_medium,
    utm_campaign: params.utm_campaign,
    utm_term: params.utm_term,
    utm_content: params.utm_content,
    channel: params['channel']
})

let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
interface IState {
    products: any[]
    pageNo: number
    toLeft: boolean
    query: any
    loading: boolean
    cartNum: number | string
    historyList: string[]
    hiddenTerm?: string
    _promo?: any
    showPromo?: boolean,
    deeplink?: any,
    hotWords?:string[],
    hint?: string
}
//小程序通讯
isMiniProgram().then(res => {
    if (res) {
        MiniBridge.on()
        MiniBridge.invoke('getSession', {}, res => {
            localStorage.setItem(BXL_USER_ID, res.userId)
            localStorage.setItem(BXL_USER_KEY, res.userKey)
        })
        MiniBridge.invoke('shareMsg', {
            title: '别样APP|海淘欧美时尚，一键直邮'
        })
    }
})
class App extends React.Component<any, IState> {
    state: IState = {
        products: [],
        pageNo: 1,
        toLeft: false,
        query: {},
        loading: false,
        cartNum: '',
        historyList: [],
        hiddenTerm: '',
        showPromo: true,
        hotWords: [],
        hint: ''
    }
    app = React.createRef<HTMLDivElement>()
    componentDidMount() {
        document.addEventListener('DOMContentLoaded', ResetRem, false)
        this.getHistory()
        this.getHotWords()
        const node = this.app.current
        node?.addEventListener('scroll', bxlutils.debounce(500, this.scroll))
        this.getCartNum()
        this.getNormalSearch()
        if (params.hiddenTerm) {
            if (!params['channel']) {
                document.title = '别样海外购'
            } else {
                document.title = '活动商品'
            }
            let q = decodeURIComponent(params.hiddenTerm);
            q = q.split('?')[1] || q;
            let deeplink: any = {};
            q.split('&').map(val => {
                deeplink[val.split('=')[0]] = val.split('=')[1]
            })
            if (deeplink.promoId) {
                this.loadPromo(deeplink.promoId)
            }
            this.setState({
                deeplink: deeplink
            },()=>{
                this.getProducts()
            })
        }
    }
    componentWillUnmount() {
        const node = this.app.current
        node?.removeEventListener('scroll', bxlutils.debounce(500, this.scroll))
        document.removeEventListener('DOMContentLoaded', ResetRem, false)
    }
    getNormalSearch = () => {
        let query: any = {}
        if(params.promoId){
            query.promoId = params.promoId
            this.loadPromo(params.promoId)
        } 
        if (params.m) query.selectMerchants = params.m
        if (params.b || params.brandId) query.selectBrands = params.b || params.brandId
        if (params.s) query.s = params.s
        if (params.q) query.q = params.q
        if (params.cids) query.selectCategory = params.cids
        if (params.tg) query.tg = params.tg
        if (params.dr) {
            query.discountRange1 = 10 - params.dr.split('-')[1] / 10
            query.discountRange2 = 10 - params.dr.split('-')[0] / 10
        }
        if (params.prs) {
            query.priceRange1 = params.prs.split('-')[0] / 100
            query.priceRange2 = params.prs.split('-')[1] / 100
        }
        this.setState(
            {
                query: query,
                hint: params.h || ''
            },
            () => {
                if(Object.keys(query).length > 0) {
                    this.getProducts()
                }
            }
        )
    }
    changeText = (text: string) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                q: text
            }
        })
    }
    getHistory = () => {
        let history = localStorage.getItem('searchHistory')
        if (history) {
            this.setState({
                historyList: history.split(',')
            })
        }
    }
    clearHistory = () => {
        localStorage.removeItem('searchHistory')
        this.setState({
            historyList: []
        })
        Toast.info('清除成功', 2)
    }
    scroll = e => {
        const { pageNo, toLeft, showPromo } = this.state
        const node = this.app.current
        const scrollTop = node?.scrollTop
        const clientTop = node?.clientHeight
        const scrollHeight = node?.scrollHeight
        if (scrollTop && scrollTop > 100 && showPromo) {
            this.setState({
                showPromo: false
            })
        } else if ((!scrollTop || scrollTop < 80) && !showPromo) {
            this.setState({
                showPromo: true
            })
        }
        if (
            scrollTop &&
            clientTop &&
            scrollHeight &&
            scrollTop + clientTop + 10 >= scrollHeight &&
            toLeft
        ) {
            this.setState(
                {
                    pageNo: pageNo + 1
                },
                () => {
                    this.getProducts()
                }
            )
        }
    }
    getHotWords = ()=>{
        getHotWords().then(res=>{
            this.setState({
                hotWords: res?.data?.hotWords
            })
        }).catch(err=>{

        })
    }
    clickHistory = (value: string) => {
        const { query } = this.state
        this.setState(
            {
                query: {
                    ...query,
                    q: value
                }
            },
            () => {
                this.getProducts()
            }
        )
    }
    search = q => {
        const { query } = this.state
        this.setState(
            {
                query: {
                    ...query,
                    ...q
                },
                pageNo: 1
            },
            () => {
                this.getProducts()
            }
        )
    }
    textSearch = () => {
        let node = document.querySelector('.App')
        if (node) node.scrollTop = 0
        this.setState(
            {
                pageNo: 1
            },
            () => {
                this.getProducts()
            }
        )
    }
    getProducts = () => {
        const {
            loading,
            historyList,
            query,
            pageNo,
            products,
            hiddenTerm,
            deeplink
        } = this.state
        if (loading) return
        this.setState({
            loading: true
        })
        if (query.q && historyList.indexOf(query.q) === -1) {
            let newHistory = [...historyList]
            newHistory.push(query.q)
            localStorage.setItem('searchHistory', newHistory.join(','))
        }
        let {
            q,
            s,
            discountRange1,
            discountRange2,
            priceRange1,
            priceRange2,
            selectBrands,
            selectCategory,
            selectMerchants,
            promoId,
            tg
        } = query
        discountRange1 = discountRange1 || 0
        discountRange2 = discountRange2 || 10
        priceRange1 = priceRange1 || 0
        searchProducts(
            {
                q,
                s,
                dr: `${(10 - discountRange2) * 10}-${(10 - discountRange1) *
                    10}`,
                prs: priceRange2
                    ? `${priceRange1 * 100}-${priceRange2 * 100}`
                    : null,
                b: selectBrands,
                cids: selectCategory,
                m: selectMerchants,
                f: (pageNo - 1) * 20,
                t: pageNo * 20,
                promoId,
                tg,
                ...deeplink
            },
            hiddenTerm
        ).then(res => {
            if (pageNo === 1) {
                this.setState({
                    products: res.data.products.filter(
                        item => item.type === 'PRODUCT'
                    )
                })
            } else {
                let data = res.data.products.filter(
                    item => item.type === 'PRODUCT'
                )
                this.setState({
                    products: products.concat(data)
                })
            }
            this.setState({
                loading: false,
                toLeft: true
            })
        })
    }
    getCartNum = () => {
        let userId = localStorage.getItem(BXL_USER_ID)
        let userKey = localStorage.getItem(BXL_USER_KEY)
        if (userId && userKey) {
            getCartProductNum().then(res => {
                this.setState({
                    cartNum: res.data.itemsQuantity
                })
            })
        }
    }
    productDetail = id => {
        tracker.send({
            webComponentClick: {
                url: window.location.href,
                component: 'product',
                pageName: 'search',
                id: id
            }
        })
        if (bxlutils.platform.isBieyangApp()) {
            window.location = bxlutils.uri.buildBieyangDeeplink('pdp', {
                productId: id
            })
        } else {
            const channel = params['channel']
            if (channel) {
                window.location.href = `https://${channel}.santasmartnetwork.com/ssh5/index.html?${slink}&#/product/${id}`
            } else {
                isMiniProgram().then(res => {
                    //小程序内
                    if (res) {
                        let arr = [
                            {
                                locationV2: 'DL_H5'
                            },
                            {
                                locationV2: PAGE_LOCATION
                            }
                        ]
                        MiniBridge.invoke('sendPageLocation', arr, res => {})
                        let url = encodeURIComponent(
                            `${BYH5}?#/product/${id}`
                        )
                        const timer = setTimeout(()=>{
                            clearTimeout(timer);
                            bxlNavigation.navigateTo({
                                url: `/pages/web/webview?url=${url}`
                            })
                        }, 100)
                    } else {
                        window.location.href = `${BYH5}?${slink}#/product/${id}`
                    }
                })
            }
        }
    }
    toOrderCart = path => {
        if (bxlutils.platform.isBieyangApp()) {
            if (path === 'cart') {
                window.location.href = `bieyang:///scp`
            } else if (path === 'order-list') {
                window.location.href = `bieyang:///order_list`
            }
        } else {
            let userKey = localStorage.getItem(BXL_USER_KEY)
            if (!userKey) {
                path = `login/${path}`
            }
            const channel = params['channel']
            if (channel) {
                window.location.href = `https://${channel}.santasmartnetwork.com/ssh5/index.html?${slink}&#/${path}`
            } else {
                isMiniProgram().then(res => {
                    //小程序内
                    if (res) {
                        let arr = [
                            {
                                locationV2: 'DL_H5'
                            },
                            {
                                locationV2: PAGE_LOCATION
                            }
                        ]
                        MiniBridge.invoke('sendPageLocation', arr, res => {})
                        setTimeout(() => {
                            let url = encodeURIComponent(
                                `${BYH5}?${slink}#/${path}`
                            )
                            bxlNavigation.navigateTo({
                                url: `/pages/web/webview?url=${url}`
                            })
                        }, 200);
                    } else {
                        window.location.href = `${BYH5}?${slink}#/${path}`
                    }
                })
            }
        }
    }

    loadPromo = promoId => {
        loadPromoDetail(promoId)
            .then(res => {
                let promo = res.data
                let { days, hours, minutes, seconds } = remainTime(
                    promo.promos[0].expiresAt
                )
                let _promo = {
                    type: promo.type,
                    title: promo.humanTitle || promo.title,
                    des:
                        promo.promos[0].inexactExpirationDesc ||
                        `${days}天${hours}小时${minutes}分钟`,
                    gifts: promo.promos[0].gifts || false
                }

                this.setState({
                    _promo: _promo
                })
            })
            .catch(e => {
                console.error(e)
            })
    }

    render() {
        const {
            query,
            toLeft,
            historyList,
            products,
            cartNum,
            loading,
            _promo,
            showPromo,
            hotWords,
            hint
        } = this.state
        return (
            <div className="App" ref={this.app}>
                <SearchBar
                    search={this.textSearch}
                    changeText={this.changeText}
                    keywords={query.q}
                    hint={hint}
                ></SearchBar>
                {_promo && showPromo && <ActionHeader _promo={_promo} />}
                <div
                    className={
                        _promo && showPromo
                            ? 'mainContent mainContentTop'
                            : 'mainContent'
                    }
                >
                    <SearchHistory
                        left={toLeft}
                        history={historyList}
                        hotWords={hotWords}
                        clearHistory={this.clearHistory}
                        clickHistory={this.clickHistory}
                    ></SearchHistory>

                    <>
                        <FilterSearch
                            left={toLeft}
                            searchProducts={this.search}
                        ></FilterSearch>
                        <ProductList
                            left={toLeft}
                            productList={products}
                            handleClickItem={this.productDetail}
                            toOrderCart={this.toOrderCart}
                            cartNum={cartNum}
                        ></ProductList>
                    </>
                </div>
                {loading && <Loading></Loading>}
            </div>
        )
    }
}

export default App
